import { IMAGE_CONFIG, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localeCa from '@angular/common/locales/ca';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeFrBE from '@angular/common/locales/fr-BE';
import localeNlBE from '@angular/common/locales/nl-BE';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { httpInterceptorProviders } from '@api/interceptors';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { provideFournierImageLoader } from '@shared/providers';
import { CustomTranslateLoader, FALLBACK_LANGUAGE } from '@shared/services/language';
import { LogsData } from '@shared/services/logs';

import { catchError, firstValueFrom, map, of } from 'rxjs';

import { APP_ROUTES } from './app.routes';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeFrBE, 'fr-BE');
registerLocaleData(localeNlBE, 'nl-BE');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeCa, 'ca');

function initializeLogLevel(): Promise<void> {
  const logs = inject(LogsData);
  return firstValueFrom(
    logs.updateLogLevelFromSession().pipe(
      catchError((error: Error) => {
        logs.error('initializeLogLevel', 'Failed to update log level from session:', error);
        return of(false);
      }),
      map(() => undefined)
    )
  );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    provideTranslateService({
      fallbackLang: FALLBACK_LANGUAGE,
      loader: provideTranslateLoader(CustomTranslateLoader),
    }),
    provideAppInitializer(() => initializeLogLevel()),
    provideFournierImageLoader(),
    {
      provide: IMAGE_CONFIG,
      useValue: {
        breakpoints: [640, 768, 1024, 1280, 1536, 1920, 2560, 3840],
      },
    },
    ...httpInterceptorProviders,
  ],
};
